import classNames from 'classnames'
import Image from 'next/image'

import { Text } from '@/shared/components/typography'
import type { HTMLInputTypeAttribute } from 'react'
import type { UseFormRegisterReturn } from 'react-hook-form'

interface FormInputProps {
  title?: string
  required: boolean
  register: UseFormRegisterReturn // NOTE: react-hook-form register 함수 (inputProps랑 오버라이딩 체크 필요함)
  rightElement?: React.ReactNode
  leftElement?: string // 이미지 URL
  className?: React.ComponentProps<'input'>['className']
  inputProps?: React.InputHTMLAttributes<HTMLInputElement> // NOTE: HTMLInputElement를 직접 컨트롤해야하는 경우
  wrapperClassName?: string
}

export interface InputField {
  title: string
  placeholder: string
  type: HTMLInputTypeAttribute
  required: boolean
  value?: string
}

const FormInput = ({
  required,
  title,
  register,
  rightElement,
  leftElement,
  className,
  inputProps,
  wrapperClassName
}: FormInputProps) => {
  return (
    <div className={classNames('flex flex-col gap-2', wrapperClassName)}>
      {/* NOTE: FormLabel로 인해 제거 예정
       사용처 - 이용자정보수정
      */}
      {title && (
        <label>
          <Text level="text2" weight="bold">
            {title}
            {required && (
              <span className="ml-1 text-red-500" aria-hidden>
                *
              </span>
            )}
          </Text>
        </label>
      )}

      <div className="relative">
        {leftElement && (
          <div className="pointer-events-none absolute left-4 top-1/2 h-[24px] w-[24px] -translate-y-1/2">
            <Image src={leftElement} fill alt="아이콘" />
          </div>
        )}
        <input
          className={classNames(
            'w-full rounded-md border border-030 py-3 focus:border-main-050',
            rightElement && 'pr-12',
            leftElement ? 'pl-11' : 'pl-5',
            className
          )}
          {...(register || {})}
          {...(inputProps || {})}
        />
        {rightElement && (
          <div className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-gray-500">
            {rightElement}
          </div>
        )}
      </div>
    </div>
  )
}

export default FormInput
